import { PAYMENT_V2_ENDPOINT_V2 } from "@/components/Pricing/v2/constants.pricing";
import { TBillingInterval, TCloudAPIResponse } from "@/types/app";
import axios from "axios";

export interface ChangeIntervalPayload {
  change_to: TBillingInterval;
  discounts?: string[];
  use_referral_credits?: boolean;
}

export interface ChangeIntervalData {
  message: string;
}

type TResponse = TCloudAPIResponse<ChangeIntervalData>;

interface ChangeIntervalOption {
  token: string;
  payload: ChangeIntervalPayload;
}

const APIURL = `${PAYMENT_V2_ENDPOINT_V2}/plan/change-interval`;

export async function handleIntervalChange(
  option: ChangeIntervalOption,
): Promise<TResponse> {
  const headers = {
    Authorization: "Bearer " + option.token,
    "Content-Type": "application/json",
  };

  try {
    const response = await axios.post(APIURL, option.payload, {
      headers,
    });

    return response.data as TResponse;
  } catch (error: any) {
    // Handle redirect case (302 response)
    if (
      error.response?.status === 302 ||
      error.response?.data?.error?.code === 302
    ) {
      return error.response.data as TResponse;
    }

    console.error("Error changing interval:", error);
    throw error;
  }
}
